import { termosStep } from '../../shared/termosSections';
import { juntadaSociedadeStep } from '../../shared/juntadaSections';

const pedidoJuntadaRecursoSociedadeConfig = {
  id: 'pedido_juntada_recurso_sociedade',
  nome: 'Pedido de Juntada de Recurso - Sociedade',
  descricao: 'Solicitação de juntada de recurso relativo à sociedade',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    documentosAdicionais: true,
    required: [
      { id: 'manifestacaoRecurso', tipoDocumentoProcesso: 489, name: 'Manifestação - Recurso', description: 'Documento contendo a manifestação do recurso', required: true }
    ]
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: '290',
    tiposAssunto: '837',
    tipoPedido: '491'
  },

  // Sem dadosRequerimentoConfig: só nome/documento de quem protocola e da
  // sociedade, sem endereço — nada mapeado em DadosRequerimento hoje.

  steps: [
    juntadaSociedadeStep(),
    termosStep()
  ]
};

export default pedidoJuntadaRecursoSociedadeConfig;
